@if (image && tag) {
    <div class="PGTagImage border rounded-circle border-{{ getColorClass() }} bg-{{ getColorClass() }}" [style.borderColor]="getColorStyle()" [style.backgroundColor]="getColorStyle()" [title]="tag">
        <img [src]="image"/>
    </div>
}
